import styled from 'styled-components';
import { WppTypography } from '@wppopen/components-library-react';
import { legendPositionType } from 'utils';

export const Main = styled.div<{
    legendPosition: legendPositionType;
}>`
    display: flex;
    flex-direction: ${({ legendPosition }) => {
        switch (true) {
            case legendPosition === 'left':
                return 'row-reverse';
            case legendPosition === 'bottom':
                return 'column';
            case legendPosition === 'top':
                return 'column-reverse';
            default:
                return 'row';
        }
    }};
    justify-content: space-between;
    column-gap: 2%;
    row-gap: 28px;
    height: auto;
    width: 100%;
`;

export const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    height: 100%;
`;

export const Plot = styled.div<{
    legendPosition: legendPositionType;
}>`
    width: ${({ legendPosition }) =>
        legendPosition === 'left' || legendPosition === 'right' ? '78%' : '100%'};
    display: flex;
    flex-direction: column;
    position: relative;
    order: 1;
`;

export const PlotHeader = styled.div`
    display: flex;
    column-gap: 18px;
`;

export const Legend = styled.div<{
    isLegendShown?: boolean;
    legendPosition: legendPositionType;
}>`
    display: ${({ isLegendShown }) => (isLegendShown ? 'flex' : 'none')};
    width: ${({ legendPosition }) =>
        legendPosition === 'left' || legendPosition === 'right' ? '20%' : '100%'};
    position: ${({ legendPosition }) =>
        legendPosition === 'left' || legendPosition === 'right' ? 'sticky' : 'static'};
    height: max-content;
    flex-direction: column;
    justify-items: start;
    top: calc(var(--header-height, 0px) + 20px);
    row-gap: 52px;
    order: 2;
`;

export const LegendWrapper = styled.div<{
    legendPosition: legendPositionType;
}>`
    display: flex;
    flex-direction: ${({ legendPosition }) => (legendPosition === 'top' ? 'row' : 'column')};
    row-gap: 8px;
    column-gap: 16px;
`;

export const LegendListWrapper = styled.div<{
    legendPosition: legendPositionType;
    isLegendsListShown?: boolean;
}>`
    display: ${({ isLegendsListShown }) => (isLegendsListShown ? 'flex' : 'none')};
    flex-direction: ${({ legendPosition }) => (legendPosition === 'top' ? 'row' : 'column')};
    row-gap: 8px;
    column-gap: 16px;
`;

export const LegendTitle = styled(WppTypography)<{
    isVisible: boolean;
}>`
    width: 180px;
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`;

export const LegendCheckboxesSection = styled.div<{
    legendPosition: legendPositionType;
}>`
    display: flex;
    row-gap: 8px;
    column-gap: 20px;
    flex-wrap: wrap;
    width: fit-content;
    flex-direction: ${({ legendPosition }) =>
        legendPosition === 'left' || legendPosition === 'right' ? 'column' : 'row'};
`;

export const LegendMore = styled(WppTypography)<{
    isLearnMoreShown: boolean;
}>`
    display: ${({ isLearnMoreShown }) => (isLearnMoreShown ? 'flex' : 'none')};
    cursor: pointer;
    color: #4d5358;
    width: 80px;

    &:hover {
        text-decoration: underline;
    }
`;

export const ChildrenWrapper = styled.div<{
    isVisible: boolean;
}>`
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`;
